import { render, staticRenderFns } from "./finishInfo.vue?vue&type=template&id=18889f1c&scoped=true&"
import script from "./finishInfo.vue?vue&type=script&lang=js&"
export * from "./finishInfo.vue?vue&type=script&lang=js&"
import style0 from "./finishInfo.vue?vue&type=style&index=0&id=18889f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18889f1c",
  null
  
)

export default component.exports